import { CloseRounded } from "@mui/icons-material";
import { Modal } from "@mui/material";

import {
  Container,
  Title,
  Wrapper,
  Image,
  Desc,
  KeyPoint,
} from "./CertificationDetailsStyles";
import { StyledLink } from "../CommonStyles/Styles";

const CertificationDetails = ({
  openModalCertification,
  setOpenModalCertification,
}) => {
  const certification = openModalCertification?.certification;

  return (
    <Modal
      open={true}
      onClose={(_, reason) => {
        if (reason === "backdropClick" || reason === "escapeKeyDown") {
          setOpenModalCertification({ state: false, project: null });
        }
      }}
    >
      <Container>
        <Wrapper>
          <CloseRounded
            style={{
              position: "absolute",
              top: "10px",
              right: "20px",
              cursor: "pointer",
            }}
            onClick={() =>
              setOpenModalCertification({ state: false, certification: null })
            }
          />
          <Image src={certification?.image} />
          <Title>{certification?.title}</Title>
          <Desc>{certification?.description}</Desc>
          <KeyPoint>
            {certification?.link ? (
              <>
                <b>Link: </b>
                <StyledLink target="new" href={certification.link}>
                  {certification.link}
                </StyledLink>
              </>
            ) : null}
          </KeyPoint>
          <KeyPoint>
            {certification?.credentials ? (
              <>
                <b>Credentials: </b>
                {certification.credentials}
              </>
            ) : null}
          </KeyPoint>
        </Wrapper>
      </Container>
    </Modal>
  );
};

export default CertificationDetails;
